import request from '@/utils/request'
import qs from "qs";

export function list(data) {
  data=qs.stringify(data)
  return request({
    url: '/FreeQuery?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}
export function detail(data) {
  data=qs.stringify(data)
  return request({
    url: '/Get?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}
export function CheckCreate(data) {
  data=qs.stringify(data)
  return request({
    url: '/CheckCreate?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}

export function FreeReplace(data) {
  data=qs.stringify(data)
  return request({
    url: '/FreeReplace?yesapi_allow_origin=1',
    method: 'POST',
    data
  })
}


// export function getInfo(params) {
//   return request({
//     url: '/user',
//     method: 'get',
//     params
//   })
// }
